import { loadingConstants } from '../constants'

const loadingReducer = (state=false, action) => {

  switch(action.type) {
    case loadingConstants.SHOW_LOADING:
      return action.show
    default:
      return state
  }

}

export default loadingReducer
